
import CyanPageWrapper, {
  store,
  defineComponent
} from "@/components/CyanPageWrapper.vue";

import { IonRow, IonCol, IonPage, IonIcon } from "@ionic/vue";

import {
  warningOutline,
  helpCircleOutline,
  checkmarkCircleOutline,
  call
} from "ionicons/icons";


export default defineComponent({
  name: "VoterList",
  components: {
    IonRow,
    IonPage,
    IonCol,
    IonIcon,
    CyanPageWrapper
  },
  setup() {
    return {
      warningOutline,
      helpCircleOutline,
      checkmarkCircleOutline,
      call
    }
  },
  data() {
    return {};
  },
  computed: {
    votantes() {
      return store.getters.listaVotantes;
    }
  },
  methods: {
    telefonoGuay(t: string) {
      return t.substr(0, 4) + "-" + t.substr(4);
    }
  }
});
